import * as React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Customized Combo Packages", "Serene, Non-Clinical Environment"];
export default function Mirroredtreatmentshowcase() {
  return <section data-section-id="262047" id="mirroredtreatmentshowcase" className="py-16 md:py-24 text-foreground bg-muted">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Content Column */}
          <div className="flex flex-col gap-6 md:gap-8">
            <div className="space-y-4">
              <h2 className="text-3xl font-default font-bold text-primary leading-tight ![padding:0px_0px_0px_51px] md:text-4xl lg:text-5xl">Combo Service</h2>
              <p className="font-sans text-muted-foreground leading-relaxed max-w-xl ![padding:0px_0px_0px_55px] !text-base">Can't pick just one? Our combo packages pair a full-body treatment with a foot treatment for a head-to-toe experience that covers all the bases. These are our most popular options for good reason; you walk out feeling like a different person.</p>
            </div>

            

            
          </div>

          {/* Image Column */}
          <div className="relative w-full aspect-[4/3] lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-lg">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/wellness_spa_treatment_room.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/wellness_spa_treatment_room.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/wellness_spa_treatment_room.png-wvc-sizes" alt="Serene spa treatment room with forest green accents and warm lighting" className="absolute inset-0 w-full h-full object-cover !p-0" loading="lazy" src="https://portlandwellnessspa.com/wp-content/uploads/2026/05/post_meet-our-practitioners-experience-and-expertise-at-portland-wellness-spa.png" src="https://portlandwellnessspa.com/wp-content/uploads/2026/05/spa_hands_at_work.png" src="https://portlandwellnessspa.com/wp-content/uploads/2026/05/wellness_therapy_combo.png" />
          </div>

        </div>
      </div>
    </section>;
}